import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './addCertificate.css'; // ✅ Reuse same CSS

const EditCourse = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    price: '',
    description: '',
    gst: '',
    days: '',
    aboutCourse: '',
    eligibility: '',
    courseIncludes: '',
    courseExcludes: '',
    image: null,
  });

  const [existingImage, setExistingImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Fetch course details
  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_API_URL+`/api/courses/${id}`);
        if (!response.ok) throw new Error('Course not found');

        const data = await response.json();

        setFormData({
          name: data.name || '',
          price: data.price || '',
          description: data.description || '',
          gst: data.gst || '',
          days: data.days || '',
          aboutCourse: data.aboutCourse || '',
          eligibility: data.eligibility || '',
          courseIncludes: data.courseIncludes || '',
          courseExcludes: data.courseExcludes || '',
          image: null,
        });

        setExistingImage(data.image || null);
      } catch (err) {
        console.error('Error fetching course:', err);
        setError('Failed to load course');
      } finally {
        setLoading(false);
      }
    };

    fetchCourse();
  }, [id]);

  // Cleanup preview URL
  useEffect(() => {
    return () => {
      if (preview) URL.revokeObjectURL(preview);
    };
  }, [preview]);

  // Handle changes
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'image' && files && files.length > 0) {
      const file = files[0];
      setFormData((prevData) => ({
        ...prevData,
        image: file,
      }));
      setPreview(URL.createObjectURL(file));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // Submit updated course
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const updatedForm = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== null && formData[key] !== '') {
        updatedForm.append(key, formData[key]);
      }
    });

    try {
      const response = await fetch(process.env.REACT_APP_API_URL+`/api/courses/${id}`, {
        method: 'PUT',
        body: updatedForm,
      });

      if (!response.ok) {
        const errorData = await response.json();
        alert("❌ Failed to update course: " + (errorData.message || response.statusText));
        setIsSubmitting(false);
        return;
      }

      alert('✅ Course updated successfully!');
      navigate('/admin/courses');
    } catch (err) {
      console.error('Update error:', err);
      alert('❌ Server error');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) return <div className="loading">⏳ Loading course...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="add-certificate-container">
      <header className="add-header">
        <img src="/flytutor_logo.png" alt="FlyTutor Logo" className="flytutor-logo" />
        <h1 className="panel-title">Edit Course</h1>
      </header>

      <div className="form-wrapper">
        <div className="admin-name">
          <span className="label">Admin Name :</span> <span className="admin">Sanjay</span>
        </div>

        <form className="certificate-form" onSubmit={handleSubmit}>
          <label>
            Course Name :
            <input type="text" name="name" value={formData.name} onChange={handleChange} required />
          </label>

          <label>
            Price :
            <input type="number" name="price" value={formData.price} onChange={handleChange} required />
          </label>

          <label>
            Description :
            <textarea name="description" value={formData.description} onChange={handleChange} required />
          </label>

          <label>
            GST :
            <input type="text" name="gst" value={formData.gst} onChange={handleChange} required />
          </label>

          <label>
            Days :
            <input type="number" name="days" value={formData.days} onChange={handleChange} required />
          </label>

          {/* ✅ Extra fields */}
          <label>
            About Course :
            <textarea name="aboutCourse" value={formData.aboutCourse} onChange={handleChange} required />
          </label>

          <label>
            Eligibility :
            <textarea name="eligibility" value={formData.eligibility} onChange={handleChange} required />
          </label>

          <label>
            Course Includes :
            <textarea name="courseIncludes" value={formData.courseIncludes} onChange={handleChange} required />
          </label>

          <label>
            Course Excludes :
            <textarea name="courseExcludes" value={formData.courseExcludes} onChange={handleChange} required />
          </label>

          <label>
            Replace Image (optional) :
            <input type="file" name="image" onChange={handleChange} />
          </label>

          {preview ? (
            <div className="image-preview">
              <p>New Image Preview:</p>
              <img src={preview} alt="Preview" width="150" />
            </div>
          ) : existingImage ? (
            <div className="image-preview">
              <p>Current Image:</p>
              <img
                src={
                  existingImage.startsWith('http')
                    ? existingImage
                    : process.env.REACT_APP_API_URL+`${existingImage}`
                }
                alt="Current"
                width="150"
              />
            </div>
          ) : null}

          <button type="submit" className="submit-btn" disabled={isSubmitting}>
            {isSubmitting ? 'Updating...' : 'UPDATE'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditCourse;
